import SkillzStyle, {lightenColor} from 'SkillzStyle';

import {
  StyleSheet,
} from 'react-native';

const {
  fontBold,
  textColorPrimary,
  viewPrimaryColor} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  addGameIconBackground: {
    backgroundColor: lightenColor(viewPrimaryColor.backgroundColor),

    // copied and pasted from CircleProgressLevelStyle
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 5,
    },
    shadowRadius: 4,
    shadowOpacity: .6,
    borderRadius: 4,
  },

  addGameIconPlus: {
    ...textColorPrimary,
    ...fontBold,
    backgroundColor: 'transparent',
    textAlign: 'center',
    textAlignVertical: 'center',
    alignSelf:'center',
    marginTop: -2,
  },
});
